import { Button } from '@w7/ui'
import './export-csv.css'

export function ExportCsvButton({
  onClick,
  disabled = false,
  count,
  title = 'Download the rows currently on screen as CSV',
}: {
  onClick: () => void
  disabled?: boolean
  count?: number
  title?: string
}) {
  const empty = disabled || count === 0
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      icon="download"
      className="w7-export-csv"
      onClick={onClick}
      disabled={empty}
      title={empty ? 'Nothing to export for this view' : title}
      aria-label="Export CSV"
      data-testid="export-csv"
    >
      <span className="w7-export-csv-label">Export</span>
      <span className="w7-export-csv-fmt" aria-hidden>
        CSV
      </span>
      {typeof count === 'number' && count > 0 ? (
        <span className="w7-export-csv-count" aria-hidden>
          {count > 999 ? '999+' : count}
        </span>
      ) : null}
    </Button>
  )
}
